// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--2p_xF","Zoom":"Zoom--NY_4Y"};